/**
 * OAuth error status when user is not on the approved list. The message payload contains this status.
 *
 * Note that PreTokenGeneration could be suffixed with V1_0|V2_0|V3_0
 * @constant {string}
 */
export const FORBIDDEN_FAILED_STATUS =
  'PreTokenGeneration failed with error [Forbidden]';

/**
 * URL search query param for the used IDP.
 */
export const IDP_URL_PARAM = 'identity_provider';

/**
 * URL search query param for login hint passed to Cognito/IdP.
 */
export const LOGIN_HINT_PARAM = 'login_hint';

/**
 * Prefix used to encode auth_factor_hint inside login_hint.
 * Cognito only forwards login_hint (standard OIDC param) to IdPs,
 * so we encode auth factor as "authfactor:<provider>" within login_hint.
 * The SHIM parses this prefix to populate ISAC's AuthFactorHint field.
 */
export const AUTH_FACTOR_HINT_PREFIX = 'authfactor:';

/**
 * Valid AuthFactorHint values matching Builder ID's AuthHintType enum.
 * These are the serialized values accepted by ISAC's StartFederationRequest.AuthFactorHint field.
 * Source: AWSIDAuthnOrchestratorServiceModel/model/workflowstructures.xml
 */
export const AuthFactorHintValues = {
  GOOGLE: 'OIDC_GOOGLE',
  APPLE: 'OIDC_APPLE',
  GITHUB: 'OIDC_GITHUB',
  AMAZON: 'OIDC_AMAZON',
} as const;

/**
 * Eula field to call Gandalf Profile backend.
 */
export const EULA_GANDALF_PROFILE_FIELD = 'eulaAcceptance';

/**
 * Default Eula field name defined from Gandalf
 */
export const DEFAULT_EULA_ATTRIBUTE_NAME = 'eula';

/**
 * This is the value of an accepted EULA
 */
export const EULA_CONFIRMATION = 'true';

/**
 * Time in MS to close logout popup window
 */
export const CLOSE_POPUP_MS = 1000;

/**
 * URL search query param for the redirect uri
 */
export const REDIRECT_URI = 'redirect_uri';

/**
 * Last used token
 */
export const LAST_USED_TOKEN = 'LAST_USED_TOKEN';

/**
 * Last used Gandalf Token
 */
export const LAST_USED_GANDALF_TOKEN = 'LAST_USED_GANDALF_TOKEN';

/**
 * Last used State
 */
export const LAST_USED_STATE = 'LAST_USED_STATE';

/**
 * URL search query param for requiring email verification
 */
export const REQUIRE_EMAIL_VERIFICATION = 'require_email_verification';

/**
 * User merge consented field to call Gandalf Profile backend.
 */
export const USER_MERGE_CONSENTED_GANDALF_PROFILE_FIELD = 'userMergeConsented';
/**
 * URL params key in local storage
 */
export const URL_PARAMS = 'URL_PARAMS';

/**
 * Merge type for APN deprecation reshellified merges.
 */
export const MERGE_TYPE_APN_DEPRECATION = 'APN_DEPRECATION';
